module.exports = __webpack_public_path__ + "img/wallpaper-white.33380426.jpeg";